module.exports = __webpack_public_path__ + "static/media/logo.e92c5fd0.png";